import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { ArInvoiceVoidApprovalPanel } from '../components/ar/ArInvoiceVoidApprovalPanel';
import { VoidList, type VoidListRow } from '../components/ar/VoidList';
import { PageHead } from '../components/layout';
import { useActiveCompanyId, useArInvoiceVoids } from '../lib/queries';

export const Route = createFileRoute('/ar/voids')({ component: ArVoidsPage });

export function ArVoidsPage() {
  const companyId = useActiveCompanyId();
  const { data, isPending, error } = useArInvoiceVoids(companyId);
  // The engine-managed (PENDING) void whose central 4-eyes decision panel
  // is open. Set from a row's "ดำเนินการอนุมัติ" action — same flow as /ap.
  const [decideVoid, setDecideVoid] = useState<VoidListRow | null>(null);

  return (
    <div className="page">
      <PageHead crumbs={['ลูกหนี้การค้า', 'ใบยกเลิก']} title="ใบยกเลิกใบแจ้งหนี้ (Void Invoices)" />
      {isPending && (
        <div className="muted" style={{ padding: 24, textAlign: 'center' }}>
          กำลังโหลด…
        </div>
      )}
      {error && (
        <div className="neg" style={{ padding: 24, textAlign: 'center' }}>
          โหลดไม่สำเร็จ: {error.message}
        </div>
      )}
      {data && <VoidList voids={data} onDecide={(v) => setDecideVoid(v)} />}

      {decideVoid && companyId && (
        <ArInvoiceVoidApprovalPanel
          companyId={companyId}
          void={decideVoid}
          onClose={() => setDecideVoid(null)}
        />
      )}
    </div>
  );
}
